import { render, staticRenderFns } from "./AgendaSingleDetails.vue?vue&type=template&id=26cb1717&"
import script from "./AgendaSingleDetails.vue?vue&type=script&lang=js&"
export * from "./AgendaSingleDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports